import {
    GET_OPENING_BALANCES,
    GET_OPENING_BALANCES_SUCCESS,
    GET_OPENING_BALANCES_FAILURE,
    CREATE_OPENING_BALANCE,
    CREATE_OPENING_BALANCE_SUCCESS,
    CREATE_OPENING_BALANCE_FAILURE,
    UPDATE_OPENING_BALANCE,
    UPDATE_OPENING_BALANCE_SUCCESS,
    UPDATE_OPENING_BALANCE_FAILURE,
    DELETE_OPENING_BALANCE,
    DELETE_OPENING_BALANCE_SUCCESS,
    DELETE_OPENING_BALANCE_FAILURE,
    BULK_UPLOAD_OPENING_BALANCES,
    BULK_UPLOAD_OPENING_BALANCES_SUCCESS,
    BULK_UPLOAD_OPENING_BALANCES_FAILURE
} from '../../../actions/index.types';

const initialState = {
    // List
    openingBalancesData: [],
    openingBalancesPagination: null,
    loading: false,
    error: null,

    // Create
    createLoading: false,
    createError: null,
    createSuccess: false,

    // Update
    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    // Delete
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false,

    // Bulk Upload
    bulkUploadLoading: false,
    bulkUploadError: null,
    bulkUploadSuccess: false,
    bulkUploadResult: null
};

const OpeningBalanceReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Opening Balances
        case GET_OPENING_BALANCES:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_OPENING_BALANCES_SUCCESS:
            return {
                ...state,
                loading: false,
                openingBalancesData: action.data?.data || [],
                openingBalancesPagination: action.data?.meta?.pagination || null,
                error: null
            };
        case GET_OPENING_BALANCES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            };

        // Create Opening Balance
        case CREATE_OPENING_BALANCE:
            return {
                ...state,
                createLoading: true,
                createError: null,
                createSuccess: false
            };
        case CREATE_OPENING_BALANCE_SUCCESS:
            return {
                ...state,
                createLoading: false,
                createSuccess: true,
                createError: null
            };
        case CREATE_OPENING_BALANCE_FAILURE:
            return {
                ...state,
                createLoading: false,
                createError: action.data,
                createSuccess: false
            };

        // Update Opening Balance
        case UPDATE_OPENING_BALANCE:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };
        case UPDATE_OPENING_BALANCE_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateSuccess: true,
                updateError: null
            };
        case UPDATE_OPENING_BALANCE_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.data,
                updateSuccess: false
            };

        // Delete Opening Balance
        case DELETE_OPENING_BALANCE:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null,
                deleteSuccess: false
            };
        case DELETE_OPENING_BALANCE_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                deleteSuccess: true,
                deleteError: null
            };
        case DELETE_OPENING_BALANCE_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action.data,
                deleteSuccess: false
            };

        // Bulk Upload
        case BULK_UPLOAD_OPENING_BALANCES:
            return {
                ...state,
                bulkUploadLoading: true,
                bulkUploadError: null,
                bulkUploadSuccess: false,
                bulkUploadResult: null
            };
        case BULK_UPLOAD_OPENING_BALANCES_SUCCESS:
            return {
                ...state,
                bulkUploadLoading: false,
                bulkUploadSuccess: true,
                bulkUploadResult: action.data,
                bulkUploadError: null
            };
        case BULK_UPLOAD_OPENING_BALANCES_FAILURE:
            return {
                ...state,
                bulkUploadLoading: false,
                bulkUploadError: action.data,
                bulkUploadSuccess: false
            };

        default:
            return state;
    }
};

export default OpeningBalanceReducer;
